import React, { memo } from 'react';
import { Button, Modal } from 'antd';
import './SimpleModal.scss';
import { GreenSuccessIcon, RedErrorIcon } from 'v2/containers/Icons';

type Action = {
  text: string;
  onClick: () => void;
};

export type ResultModalProps = {
  visible: boolean;
  isSuccess: boolean;
  title?: string;
  message?: string;
  primaryAction?: Action;
};

const ResultModal: React.FC<ResultModalProps> = ({
  visible,
  isSuccess,
  title,
  message,
  primaryAction,
}) => {
  return (
    <Modal
      open={visible}
      centered
      zIndex={999999}
      modalRender={() => (
        <div className="simple-modal-container">
          <div className="flex-items-center mt-16">
          {isSuccess ? 
            GreenSuccessIcon : RedErrorIcon
          }
          </div>
          <p className="ds-typo-title2 text-center m-0">{title}</p>
          <p className="ds-typo-body1 text-center m-0 mt-8">{message}</p>
          <div className="flex-items-center mt-16">
              <Button
                className="simple-modal-action-button"
                type="primary"
                onClick={() => {
                  primaryAction?.onClick();
                }}
              >
                {primaryAction?.text}
              </Button>
          </div>
        </div>
      )}
    />
  );
};

export default memo(ResultModal);
